module.exports = __webpack_public_path__ + "static/img/fail.27e493b9.png";